import * as z from "zod";

export const uploadMerchantFeedbackScreenshot = {
  name: "uploadMerchantFeedbackScreenshot" as const,
  input: z.object({
    // The feedbackId returned from submitMerchantFeedback. The rendered
    // screenshot is attached to that row and embedded into its already-posted
    // Slack message.
    feedbackId: z.string().min(1),
  }),
  output: z.object({ success: z.literal(true) }),
  // The page's captured HTML — a self-contained snapshot of the merchant's
  // viewport (scripts stripped, asset links base-resolved) — sent as a
  // multipart file so a large document streams as bytes rather than a JSON
  // string. It's rendered to an image server-side via Gotenberg, so the client
  // never rasterizes and never freezes. Best-effort: absent when capture fails.
  files: true as const,
};
